export default __webpack_public_path__ + "static/media/icon-edit.e712e242.svg";